/**
 * Styling helpers for the stacked bars on the profits page.
 *
 * A day's bar is drawn as one piece: only the topmost segment is rounded,
 * instead of each segment carrying its own rounded border. The day under the chart's midpoint is in focus; the other
 * days are faded.
 */
export const ProfitBars = {
  /** Corner radius of the top of a bar, in pixels. */
  RADIUS: 5,

  /** Opacity of the bars that are not in focus. */
  FADED: 0.5,

  /**
   * Index of the topmost visible dataset with a positive value at `index`,
   * or -1 when the bar has no positive segment.
   */
  topIndex (values: number[][], visible: boolean[], index: number): number {
    for (let k = values.length - 1; k >= 0; k--) {
      if (visible[k] && (values[k][index] ?? 0) > 0) return k
    }
    return -1
  },

  /** Index of the bar under the midpoint of the visible range. */
  focusIndex (min: number, max: number): number {
    return Math.floor((min + max) / 2)
  },

  /** `#rrggbb` as `rgba(r, g, b, alpha)`. */
  fade (hex: string, alpha: number): string {
    const n = parseInt(hex.slice(1), 16)
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`
  }
}
